import React from 'react';
import { motion } from 'framer-motion';
export function Bonos() {
  const bonos = [{
    num: '01',
    name: 'Guía de Calentamiento y Enfriamiento',
    desc: 'Rutinas específicas de vóley antes y después de cada sesión. Reduce el riesgo de lesiones un 40%.'
  }, {
    num: '02',
    name: 'Calendario de Temporada Anual',
    desc: 'El mapa completo de las 28 semanas con objetivos, evaluaciones y competencias programadas.'
  }, {
    num: '03',
    name: 'Guía de Nutrición Básica',
    desc: 'Qué comer antes, durante y después del partido para rendir al máximo en los 5 sets.'
  }, {
    num: '04',
    name: 'Guía de Análisis del Rival',
    desc: 'La planilla simple de 5 datos que te da ventaja táctica antes de que empiece el partido.'
  }, {
    num: '05',
    name: 'Test de Condición Física',
    desc: 'Batería completa de tests con tablas de referencia por edad y posición.'
  }, {
    num: '06',
    name: 'Reglamento Interno del Equipo',
    desc: 'El documento listo para firmar que transforma un grupo en un equipo que se auto-regula.'
  }];
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-5xl md:text-6xl font-bebas mb-4" data-id="element-20">
            <span className="text-white" data-id="element-21">Más los </span>
            <span className="text-brand-DEFAULT" data-id="element-22">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-xl text-text-secondary mb-4" data-id="element-23">
            Incluidos en todas las ofertas sin costo extra
          </p>
          <div className="inline-block bg-dark-card border border-dark-border text-brand-gold font-bold px-6 py-2 rounded-full uppercase tracking-wide" data-id="element-24">
            Valor total: USD 39{' '}
            <span className="line-through opacity-50 ml-2" data-id="element-25"></span>{' '}
            <span className="text-white" data-id="element-26">GRATIS</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-27">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative bg-dark-card border border-dark-border p-8 rounded-xl overflow-hidden group hover:border-brand-DEFAULT/50 transition-colors" data-id="element-28">
              <div className="absolute top-0 right-0 bg-dark-border text-brand-accent font-bold px-4 py-1 rounded-bl-lg text-sm" data-id="element-29">
                GRATIS
              </div>
              <div className="flex items-center space-x-3 mb-4" data-id="element-30">
                <span className="text-4xl font-bebas text-brand-DEFAULT" data-id="element-31">
                  {bono.num}
                </span>
                <span className="text-2xl" data-id="element-32">🎁</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-33">{bono.name}</h3>
              <p className="text-text-secondary text-sm leading-relaxed mb-4" data-id="element-34">
                {bono.desc}
              </p>
              <p className="text-brand-accent font-bold text-sm" data-id="element-35">GRATIS</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}